(function(){"use strict";try{if(typeof document<"u"){var e=document.createElement("style");e.appendChild(document.createTextNode(".help-center-articles-combobox{width:100%!important}.help-center-articles-combobox .swan-combobox-button{display:none!important}.query-suggestions-combobox-popover{z-index:1!important}")),document.head.appendChild(e)}}catch(o){console.error("vite-plugin-css-injected-by-js",o)}})();
import { default as a } from "./help-center-articles-search2.js";
export {
  a as HelpCenterSearch
};
//# sourceMappingURL=help-center-articles-search.js.map
